import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              <span className="text-secondary">MARKHOR</span> GROUP
            </h3>
            <p className="text-gray-300 mb-4">
              Global commodity trading and logistics solutions provider based in London.
            </p>
            <p className="text-gray-300">
              Serving clients across Europe, Asia, and Africa with reliable supply chain management.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-secondary transition duration-200"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="text-gray-300 hover:text-secondary transition duration-200"
                >
                  Products We Handle
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-secondary transition duration-200"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-secondary transition duration-200"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Commodities */}
          <div>
            <h4 className="font-bold text-lg mb-4">Our Commodities</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">Fertiliser (Potash MOP)</li>
              <li className="text-gray-300">Thermal Coal</li>
              <li className="text-gray-300">Wheat</li>
              <li className="text-gray-300">Metals (Titanium)</li>
              <li className="text-gray-300">Custom Sourcing Available</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-center md:text-left mb-4 md:mb-0">
              &copy; {currentYear} Markhor Group. All rights reserved. | London, United Kingdom
            </p>
            <div className="flex space-x-6">
              <a
                href="mailto:info@markhor-group.com"
                className="text-gray-400 hover:text-secondary transition duration-200"
              >
                info@markhor-group.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
